import { CustomIcon } from "components/icon/customIcon.component";
import {
  ColumnContainer,
  Container,
  SearchContainer,
  SimpleRow,
  TabsContainer,
  TabsStyled,
  TabStyled,
} from "./organizationalStructure.styled";
import { Color } from "config/colors";
import { useEffect, useState } from "react";
import { Text } from "components/Typography/text.styled";
import { useTranslation } from "react-i18next";
import { FontSize, FontFamily } from "config/font";
import { CreateModal } from "./createModal.component";
import { Entity } from "model/OrganizationalStructure";
import { EntityStructure } from "./entityStructure.component";
import { EditModal } from "./editModal.component";
import { SearchComponent } from "../general/search/search.component";

type Props = {
  entities: Entity[];
};

export const OrganizationalStructureOverview: React.FC<Props> = (props) => {
  const [inputValue, setInputValue] = useState<string>();
  const { t } = useTranslation();
  const [selectedEntity, setSelectedEntity] = useState<Entity | undefined>(
    props.entities[0]
  );
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const truncateText = (text: string, maxLength: number = 15) => {
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  const handleSelectEntity = () => {
    if (showEditModal) return;

    if (!selectedEntity && props.entities.length > 0) {
      setSelectedEntity(props.entities[0]);
    } else if (
      selectedEntity &&
      !props.entities.find((e) => e.id === selectedEntity.id)
    ) {
      setSelectedEntity(props.entities[0]);
    }
  };

  useEffect(() => {
    handleSelectEntity();
  }, [props.entities, selectedEntity, showEditModal, showCreateModal]);

  return (
    <>
      <Container>
        <TabsContainer>
          <TabsStyled>
            {props.entities.map((entity) => {
              const entityName =
                entity.name === "Unhandled"
                  ? t("OrganizationalStructure.Unhandled")
                  : entity.name;
              return (
                <TabStyled
                  active={selectedEntity?.id === entity.id}
                  onClick={() => {
                    setSelectedEntity(entity);
                  }}
                >
                  <SimpleRow>
                    <Text
                      fontSize={FontSize.Standard}
                      fontFamily={FontFamily.MontserratSemiBold}
                      color={Color.Black}
                      style={{ margin: "0 auto", marginTop: 30 }}
                    >
                      {props.entities.length > 3 || entityName.length > 10
                        ? truncateText(entityName)
                        : entityName}
                    </Text>
                    {selectedEntity?.id === entity.id &&
                      selectedEntity.name !== "Unhandled" && (
                        <CustomIcon
                          name="settings"
                          color={Color.Black}
                          size="16px"
                          style={{
                            margin: "0 auto",
                            marginTop: 30,
                          }}
                          onClick={() => setShowEditModal(true)}
                        />
                      )}
                  </SimpleRow>
                </TabStyled>
              );
            })}
          </TabsStyled>
          <ColumnContainer
            style={{ marginLeft: 25, cursor: "pointer", marginTop: 14 }}
            onClick={() => setShowCreateModal(true)}
          >
            <CustomIcon
              name="add"
              color={Color.Black}
              size="10px"
              style={{ margin: "0 auto" }}
            />
            <Text fontSize={FontSize.Tiny}>
              {t("OrganizationalStructure.CreateEntity")}
            </Text>
          </ColumnContainer>
        </TabsContainer>
        <SearchContainer style={{ marginTop: 10 }}>
          <SearchComponent
            placeholder={t("OrganizationalStructure.SearchPlaceholder")}
            value={inputValue}
            onChange={(e: any) => {
              setInputValue(e.currentTarget.value);
            }}
            showSearchButton={true}
          />
        </SearchContainer>
      </Container>
      {selectedEntity && (
        <EntityStructure searchText={inputValue} entityId={selectedEntity.id} />
      )}
      <CreateModal
        setShowCreateModal={setShowCreateModal}
        showCreateModal={showCreateModal}
        type={"Entity"}
      />
      {showEditModal && selectedEntity && (
        <EditModal
          setShowEditModal={setShowEditModal}
          showEditModal={showEditModal}
          type={"Entity"}
          id={selectedEntity.id}
          name={selectedEntity.name}
        />
      )}
    </>
  );
};
